module.exports = __webpack_public_path__ + "static/img/sam-cover@3x.eb464336.png";